// This file was auto-generated by Fern from our API Definition.
/**
 * Whether the bot is in a discovered space, and if not, who can put it
 * there. Unset where the platform reports no membership.
 */
export const ChannelSpaceMembership = {
    Member: "member",
    Joinable: "joinable",
    InviteRequired: "invite_required",
};
